import React from 'react';

export default function LoadingScreen() {
  return (
    <p style={{ marginTop: '150px', textAlign: 'center' }}>{'Loading ...'}</p>
  );
}
